"use client";

import { useTranslations } from "next-intl";

const TABLE_ROWS = [
	{ labelKey: "row1Label", valueKey: "row1Value" },
	{ labelKey: "row2Label", valueKey: "row2Value" },
	{ labelKey: "row3Label", valueKey: "row3Value" },
	{ labelKey: "row4Label", valueKey: "row4Value" },
	{ labelKey: "row5Label", valueKey: "row5Value" },
	{ labelKey: "row6Label", valueKey: "row6Value" },
	{ labelKey: "row7Label", valueKey: "row7Value" },
	{ labelKey: "row8Label", valueKey: "row8Value" },
	{ labelKey: "row9Label", valueKey: "row9Value" },
	{ labelKey: "row10Label", valueKey: "row10Value" },
] as const;

const CELL_BORDER = "border-b border-[#e2e2e2]";
const CELL_PY = "py-5 sm:py-[22px]";

export interface MetalBendingCapabilitiesProps {
	translationNamespace?: string;
}

/**
 * 标题区与稿一致：浅米色底、左栏两行标题（第二行右侧短绿线）、右栏副文左对齐顶对齐；表格仅横线。
 */
export default function MetalBendingCapabilities({
	translationNamespace = "metalBendingCapabilities",
}: MetalBendingCapabilitiesProps) {
	const t = useTranslations(translationNamespace);

	return (
		<section className="w-full bg-[#FCFFF4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 grid gap-8 sm:mb-8 md:mb-10 lg:mb-12 lg:grid-cols-2 lg:items-start lg:gap-12 xl:gap-16 2xl:gap-24">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						<span className="block leading-[1.12]">{t("titlePrefix")}</span>
						<span className="mt-0.5 flex items-end gap-2.5 leading-[1.12] sm:gap-3">
							<span>{t("titleAccent")}</span>
							<span
								className="h-[3px] w-[3.25rem] shrink-0 rounded-full bg-themePrimary400 sm:w-[3.75rem]"
								aria-hidden
							/>
						</span>
					</h2>
					<p className="text-left text-sm font-normal leading-relaxed text-black md:text-base">
						{t("intro")}
					</p>
				</div>

				<div className="overflow-x-auto">
					<table className="w-full min-w-[600px] border-collapse text-left">
						<colgroup>
							<col style={{ width: "40%" }} />
							<col style={{ width: "60%" }} />
						</colgroup>
						<thead>
							<tr className={`${CELL_BORDER} border-t border-[#e2e2e2]`}>
								<th
									scope="col"
									className={`${CELL_PY} pl-24 text-sm font-bold text-black sm:pr-8 sm:text-base`}
								>
									{t("colDescription")}
								</th>
								<th scope="col" className={`${CELL_PY} text-sm font-bold text-black sm:text-base`}>
									{t("colTechnicalSpecs")}
								</th>
							</tr>
						</thead>
						<tbody>
							{TABLE_ROWS.map((row) => (
								<tr key={row.labelKey} className={CELL_BORDER}>
									<td className={`${CELL_PY} p-6 pl-24 text-sm font-bold text-black sm:pr-8 sm:text-base`}>
										{t(row.labelKey)}
									</td>
									<td className={`${CELL_PY} text-sm font-normal leading-relaxed text-black md:text-base`}>
										{t(row.valueKey)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
}
